export const AddTrialApi = Symbol.for('AddTrialApi');

/**
 * 添加试用权限的参数
 */
export interface AddFreePkgParams {
    /** 权限类型 ('AIR' | 'LS' | 'INSIGHTS') */
    empowerType: string;
    /** 来源标识 */
    from?: string;
    /** 扩展参数体 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=272192900 */
    extendBody?: Record<string, any>;
}

/**
 * Add Trial API
 * 处理试用权限添加相关的接口调用
 */
export interface AddTrialApi {
    /**
     * 检查是否需要添加试用权限
     * @param empowerType - 权限类型 ('AIR' | 'LS' | 'INSIGHTS')
     * @param extendBody - 扩展参数体
     * @returns 是否需要添加试用权限
     */
    needAddFreePkg(empowerType: string, extendBody: Record<string, any>): Promise<boolean>;

    /**
     * 添加试用权限
     * @param params - 添加试用权限的参数
     */
    addFreePkg(params: AddFreePkgParams): Promise<void>;
}
